import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
  ViewChild
} from '@angular/core';
import { Router } from '@angular/router';
import { SettingsService, _HttpClient } from '@delon/theme';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { FcwidgetService } from 'src/app/core/util/fcwidget.service';
import { SharedModule } from 'src/app/shared/shared.module';
import { QbotWidgetService } from '../../../../routes/ai/_providers/qbot-widget.service';

@Component({
  selector: 'app-license-notification',
  templateUrl: './license-notification.component.html',
  styles: [
    `
      .module-viewport {
        height: 200px;
      }

      .license-notification{
        position: fixed;
        z-index: 1000;
        bottom: 24px;
        right: 24px;
        width: 400px;
        padding: 16px 40px 16px 24px;
        background-color: #fff;
        border-radius: 8px;
        box-shadow: 0 8px 24px rgba(0, 23, 77, 0.2);
      }
    `
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SharedModule]
})
export class LicenseNotificationComponent {
  @ViewChild('template') template!: any;

  qaBotWidgetService = inject(QbotWidgetService);

  get planLink() {
    return `/account/subscription/subscribe/${this.settings.user['company']['tenantId']}`;
  }

  license = signal(null as any);

  constructor(
    private readonly settings: SettingsService,
    private readonly fcWidget: FcwidgetService,
    private readonly notificationSrv: NzNotificationService,
    private readonly http: _HttpClient,
    private readonly router: Router
  ) {
    this.http.get('api/license/mylicense').subscribe(result => {
      this.license.set(result);
      if (!!this.license()) {
        if (
          this.license().daysLeft < 16 &&
          this.license().license &&
          this.license().license?.isTrialKey &&
          !!this.qaBotWidgetService.notificationIsClosed()
        ) {
          this.qaBotWidgetService.showNotificationLayout.set(true);
          this.qaBotWidgetService.notificationIsClosed.set(false);
        }
      } else {
        this.notificationSrv.remove('trial-notification');
      }
    });
  }

  onClose() {
    this.notificationSrv.remove('trial-notification');
    this.qaBotWidgetService.showNotificationLayout.set(false);
  }

  navigateToPlan() {
    this.notificationSrv.remove();
    this.router.navigateByUrl(this.planLink);
  }

  openLiveChat() {
    this.notificationSrv.remove();
    this.fcWidget.open();
  }
}
